export const REFRESH_INTERVAL = 10000;
